var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero__cta"},[(_vm.text)?_c('div',{staticClass:"upper"},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e(),_vm._v(" "),(_vm.link)?_c('div',{staticClass:"lower"},[_c('primary-button',{attrs:{"link":JSON.parse(this.link),"label":'Signs Inc.'}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/signs.stagingwebsite.dev/web/app/themes/signs/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/signs.stagingwebsite.dev/web/app/themes/signs/node_modules/vue-loader/lib?{}!./scripts/vue/HeroCta.vue?vue&type=template&id=4c93711a&scoped=true&
// module id = 418
// module chunks = 0